import { createReducer } from '@reduxjs/toolkit';
import { switchAccountSuccess } from 'store/account/actions';
import * as actions from '../actions.common';
import { ClinicNotesDownloadState } from '../types';

export const initialState: ClinicNotesDownloadState = {
  loading: false,
  response: null,
  error: null
};

const clinicNotesDownload = createReducer(initialState, {
  [actions.CLINIC_NOTES_DOWNLOAD_DOCUMENT]: state => {
    state.loading = true;
  },
  [actions.CLINIC_NOTES_DOWNLOAD_DOCUMENT_SUCCESS]: (state, action) => {
    state.loading = false;
    state.response = action.payload;
  },
  [actions.CLINIC_NOTES_DOWNLOAD_DOCUMENT_FAIL]: (state, action) => {
    state.loading = false;
    state.error = action.error;
  },
  [switchAccountSuccess.type]: () => initialState
});

export default clinicNotesDownload;
